'use client'

import { useIntl } from 'react-intl'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { PricingRuleModel } from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { formatCurrency } from '@marketplace-web/currency/currency-data'

type Props = {
  priceRule: PricingRuleModel
}

const PriceRuleTitle = ({ priceRule }: Props) => {
  const { locale } = useIntl()
  const translate = useTranslate('available_discounts.subtitle')
  const { type, exactAmount, fixedAmount, percentage, currency } = priceRule

  let title

  if (exactAmount !== null) {
    title = translate(`exact_amount_discount.${type}`, {
      amount: formatCurrency(exactAmount, {
        currency,
        locale,
      }),
    })
  }

  if (fixedAmount !== null) {
    title = translate(`fixed_amount_discount.${type}`, {
      amount: formatCurrency(fixedAmount, {
        currency,
        locale,
      }),
    })
  }

  if (percentage !== null) {
    const isFree = percentage === '100' ? '_free' : ''

    title = translate(`percentage_discount.${type}${isFree}`, {
      discount: percentage,
    })
  }

  if (!title) return null

  return <h2 className="available_discounts__price-rule-title">{title}</h2>
}

export default PriceRuleTitle
